// Call routing: numbers + transfer policy.
import React from 'react';
import {
  NumberField, SelectField, SwitchField, TextField,
} from './fields';
import { TRANSFER_FALLBACKS, TRANSFER_TYPES } from './constants';

export default function RoutingSection({ value, onChange }) {
  const set = (key) => (v) => onChange({ ...value, [key]: v });
  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <TextField label="Primary sales number" value={value.primary_sales_number} onChange={set('primary_sales_number')} />
        <TextField label="Sales manager number" value={value.sales_manager_number} onChange={set('sales_manager_number')} />
        <TextField label="Finance manager number" value={value.finance_manager_number} onChange={set('finance_manager_number')} />
        <TextField label="After-hours number" value={value.after_hours_number} onChange={set('after_hours_number')} />
      </div>
      <SwitchField
        label="Allow live transfer"
        description="Agent can bridge the caller to a human."
        value={value.allow_live_transfer}
        onChange={set('allow_live_transfer')}
      />
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <SelectField
          label="Transfer type"
          value={value.transfer_type}
          onChange={set('transfer_type')}
          options={TRANSFER_TYPES}
        />
        <NumberField
          label="Max ring seconds"
          value={value.max_ring_seconds}
          onChange={set('max_ring_seconds')}
          min={5}
          max={120}
        />
        <SelectField
          label="Transfer fallback"
          value={value.transfer_fallback}
          onChange={set('transfer_fallback')}
          options={TRANSFER_FALLBACKS}
        />
      </div>
    </div>
  );
}
